export const about = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lighttextDesc: true,
    topLine: 'About Me',
    headline: 'Gym, Soccer, and Code',
    description: 'I am an undergraduate at the University of New South Wales (UNSW) studying Computer Science and Finance. When I am not working towards understanding the links between technology and finance, I spend time with loved ones and rigorously exercise... and code, of course. I love programming in general and continue to explore different fields in computer science through coding competitions and personal projects. In addition, I am developing an interest in consulting as I expand my experience from internal consulting competitions at UNSW.',
    imgStart: false,
    img: '/images/undraw_junior_soccer_6sop.svg',
    alt: 'soccer',
    dark: true,
    primary: true,
    darkText: false
  }

export const education = {
    id: 'education',
    lightBg: true,
    lightText: false,
    lighttextDesc: false,
    topLine: 'Educational Background',
    headline: 'From Singapore to Australia',
    description: "I attended an international school outside of Australia; there, I gained a deep appreciation for the vast cultural differences and sensitivities as I volunteered for different initiatives with a diverse group of friends. Growing up in Singapore, I was also fortunate to witness an environment that advanced and used technology to automate processes around the country; this impressed me as I noticed how technology went hand-in-hand in developing Singapore's economy. Thus, when I returned to my home country of Australia to study at the University of New South Wales, I pursued my desire to understand how to connect technology to people.",
    imgStart: true,
    img: '/images/cdnlogo.com_unsw.svg',
    alt: 'unsw',
    dark: false,
    primary: false,
    darkText: true
}